import { Cognito } from '@caplend/cognito-auth';

const userPoolData = {
  UserPoolId: process.env.REACT_APP_COGNITO_USER_POOL,
  ClientId: process.env.REACT_APP_COGNITO_CLIENT_ID,
};

export default new Cognito(userPoolData);
